import { useEffect, useMemo, useState } from "react";
import {
  useQpmCatalogListQuery,
  useQpmCatalogResolveActiveQuery,
} from "@/services/backend/qpm/catalog/api/catalog-api";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";

export function useProcessCatalogSelection(customerId: string) {
  const { companyId } = useActiveCompany();
  const [catalogId, setCatalogId] = useState("");
  const {
    data: catalogList,
    isLoading,
    error,
  } = useQpmCatalogListQuery({
    company: { active: true, values: [companyId] },
  });
  const { data: activeRelease } = useQpmCatalogResolveActiveQuery({
    customerId,
  });

  const selectableCatalogs = useMemo(
    () =>
      (catalogList?.items ?? []).filter(
        (catalog) => !catalog.customerId || catalog.customerId === customerId,
      ),
    [catalogList?.items, customerId],
  );

  useEffect(() => {
    if (!selectableCatalogs.length) {
      setCatalogId("");
      return;
    }

    const selectedCatalogStillAvailable = selectableCatalogs.some(
      (catalog) => catalog.id === catalogId,
    );
    if (catalogId && selectedCatalogStillAvailable) {
      return;
    }

    const customerCatalog = selectableCatalogs.find(
      (catalog) => catalog.customerId === customerId,
    );
    const activeCatalog = activeRelease
      ? selectableCatalogs.find(
          (catalog) => catalog.id === activeRelease.catalogId,
        )
      : undefined;

    setCatalogId(
      customerCatalog?.id ??
        activeCatalog?.id ??
        selectableCatalogs[0]?.id ??
        "",
    );
  }, [selectableCatalogs, catalogId, customerId, activeRelease]);

  return { catalogId, setCatalogId, selectableCatalogs, isLoading, error };
}
